export default __webpack_public_path__ + "static/media/cloud.61dc645c.svg";